module.exports = __webpack_public_path__ + "static/img/photo-store-locator.a2c9524.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/large/photo-store-locator.jpg
// module id = gNjp
// module chunks = 1